module.exports = __webpack_public_path__ + "static/img/VN@2x.22788cd1.jpg";